import { render, staticRenderFns } from "./setDesignType.vue?vue&type=template&id=62b03231&scoped=true"
import script from "./setDesignType.vue?vue&type=script&lang=js"
export * from "./setDesignType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b03231",
  null
  
)

export default component.exports